import { Group } from '../../../modules/admin/models';

export const AUTHENTICATE = '@AUTH/AUTHENTICATE';
export const LOGOUT = '@AUTH/LOGOUT';
export const SET_PROFILE = '@AUTH/SET_PROFILE';

export interface AuthenticateAction {
  type: typeof AUTHENTICATE;
  payload: {
    accessToken: string;
    refreshToken: string;
  };
}

export interface LogoutAction {
  type: typeof LOGOUT;
}

export interface SetProfileAction {
  type: typeof SET_PROFILE;
  payload: {
    id: number;
    username: string;
    email: string;
    name: string;
    groups: Group[];
    terms_ack: boolean;
    first_login: boolean;
    license: string;
  };
}

export type ActionTypes = AuthenticateAction | LogoutAction | SetProfileAction;
